<template>
	<div class="login-wrapper">
		
		<h2 class="title">注册</h2>
		<div class="form">
			<el-form :model="form" ref="form" :rules="rules" class="form">
				<el-form-item prop="account">
				    <el-input v-model="form.account" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item prop="email">
				    <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
				</el-form-item>
				<el-form-item prop="newPassword">
				    <el-input v-model="form.newPassword" placeholder="请输入密码" show-password></el-input>
				</el-form-item>
				<el-form-item prop="confirmPass">
				    <el-input v-model="form.confirmPass" placeholder="请确认密码" show-password></el-input>
				</el-form-item>
				<el-form-item prop="mobile">
				    <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item prop="code">
				    <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
				    <el-button type="warning" class="code-btn" @click="getCode" :disabled="buttonDisable">{{buttonName}}</el-button>
				</el-form-item>
			</el-form>
			
		</div>
		<el-button type="warning" class="login-btn" @click="submitForm">注册</el-button>
		<div class="changeItem">
			<el-link type="info" style="float: left;margin-top: 10px;" @click="toLogin">已有账号？<a style="color: #FF842E;">登录</a></el-link>
		</div>
		<el-divider><i style="font-size: 24px;color: #CCD1D8;">·</i></el-divider>
		<div>注册登录即代表同意<el-link type="warning">《欢软用户协议》</el-link><el-link type="warning">《欢软隐私政策》</el-link></div>
	</div>
</template>

<script>
import { login,register,registerCode  } from '@/api/login/login'
var index;
export default {
  data () {
	  var validateNewPass = (rule, value, callback) => {
	      if (value !== this.form.newPassword) {
	         callback(new Error('两次输入密码不一致!'));
	      } else {
	        callback()
	      }
	    }
	  var validateMobile = (rule, value, callback) => {
		  const regEx = /^[1][3-9]\d{9}$/;
	      if (!regEx.test(value)) {
	         callback(new Error('手机号格式不正确，请重新输入!'));
	      } else {
	        callback()
	      }
	    } 
	  return {
	    form:{
	  	  account: '',
	  	  email: '',
	  	  mobile: '',
	  	  code: '',
	  	  newPassword: '',
	  	  confirmPass: '',
	    },
	    logintype: 1,
	    buttonName: '获取验证码',
	    buttonDisable: false,
	    timeNum: 59,
	    rules: {
	    	account:  [{ required:true, message: '请输入用户名',trigger: 'blur'}],
			email:  [{ required:true, message: '请输入邮箱',trigger: 'blur'}],
	    	mobile:  [{ required:true, message: '请输入手机号',trigger: 'blur'},
			{ validator: validateMobile,trigger: 'blur'}],
			code: [{ required:true, message: '请输入验证码',trigger: 'blur'}],
	    	newPassword: [{ required:true, message: '请输入新密码',trigger: 'blur'},
	    	{ min: 6, message: '密码长度不低于6位',trigger: 'blur'}],
	    	confirmPass:[{ required:true, message: '请再次填写确认',trigger: 'blur'},
	    	{ validator: validateNewPass,trigger: 'blur'}]
	    }
    }
  },
  methods: {
	toLogin(){
		// this.$emit('toLogin',true)
		this.$router.push('/login')
	},
    async getCode(){
		this.buttonName = this.timeNum+'s后重新获取'
		this.buttonDisable = true;
		index = setInterval(()=>{ 
			this.timeNum--;		
			this.buttonName = this.timeNum+'s后重新获取';
			
		},1000)
		const res = await registerCode({mobile:this.form.mobile})
		if (res.code === 0) {
			this.$message.success('验证码发送成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
	submitForm(){
		this.$refs.form.validate(async (valid) => {
		  if (valid) {
			const res = await register({
			  "username": this.form.account,
			  "password": this.form.newPassword,
			  "email": this.form.email,
			  // "nickname": "欢乐软件人",
			  mobile: this.form.mobile,
			  verfCode: this.form.code
			})
			if (res.code === 0) {
				this.$message.success('注册成功')
				this.$router.push({path:'/login'})
			} else {
			  this.$message.error(res.msg)
			}
		  } else {
			console.log('error submit!!');
			return false;
		  }
		});
	}
  },
  watch:{
	 timeNum(newval){
		 if(newval==0){
		 	this.buttonName = '获取验证码';
		 	this.buttonDisable = false;
		 	clearInterval(index);
			this.timeNum = 59;
		 }
	 } 
  },
  mounted () {
    
  },
  destroyed(){
	  clearInterval(index)
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper{
	background-color: #fff;
	border-radius: 20px;
	width: 20vw;
	min-width: 300px;
	padding: 20px 30px;
	text-align: center;
	.title{
		margin: 0 0 20px;
	}
	.el-form-item{
		margin-bottom: 15px;
	}
	.el-form-item__error{
		padding-top: 1px;
	}
	.login-btn{
		width: 100%;
		background-color: #FF842E;
	}
	.changeItem:after {
	  content: "";
	  display: table;
	  clear: both;
	}
	.account{
		margin-bottom: 10px;
	}
	.form{
		position: relative;
		margin-bottom: 20px;
		.code-btn{
			position: absolute;
			bottom: 0;
			right: 0;
			background-color: #FF842E;
		}
		/deep/.el-input.is-active .el-input__inner,
		/deep/.el-input__inner:focus{
			border-color: #C0C4CC;
		}
	}
	.loginType{
		margin-top: 15px;
		&>div{
			display: inline-block;
			text-align: center;
			margin-right:30px;
			&:last-child{
				margin-right: 0;
			}
			.icon-wrapper{
				border-radius: 50%;
				width: 50px;
				height: 50px;
				border: 1px solid #7A818C;
				display: flex;
				justify-content: center;
				align-items: center;
				.iconfont{
					font-size: 28px;
					color: #7A818C;
				}
			}
			/* 针对手机的样式 */
			@media (max-width: 767px) {
			  .icon-wrapper{
			  	width: 40px;
			  	height: 40px;
			  	.iconfont{
			  		font-size: 24px;
			  	}
			  }
			}
		}
	}
	.el-link.el-link--warning{
		color: #FF842E;
	}
}
</style>